import { boardsApi } from '../../../api';
import type { Board } from '../../../types';
import type { BoardStateSetter } from '../types';

export const createJoinBoard = (set: BoardStateSetter) => {
  return async (inviteCode: string): Promise<Board> => {
    const board = await boardsApi.join(inviteCode);
    set((state) => {
      if (state.boards.find((b) => b.id === board.id)) {
        return state;
      }
      return { boards: [...state.boards, board] };
    });
    return board;
  };
};
